export default "__VITE_ASSET__BxC3Dd_T__"